// Remove no-js class from body when Javascript is activated
document.body.classList.remove('no-js');
document.body.classList.add('js')

// Make whole card clickable
function clickableCard(element, link) {
    element.addEventListener('click', (e) => {
        if (!_.isEmpty(link.getAttribute('type') === 'application/pdf' || link.getAttribute('type') === 'video/mp4')) {
            window.open(link, '_blank');
            return
        }
        window.open(link, '_self')
    })

    element.style.cursor = 'pointer';
    element.classList.add('clickable');
}

const teasers = document.querySelectorAll(
    '.teaser'
);

if (!_.isEmpty(teasers)) {
    Array.from(teasers).forEach(teaser => {
        const link = teaser.getElementsByTagName('A')[0];

        if (!_.isNil(link)) {
            clickableCard(teaser, link);
        }
    });
}

// Drupal behaviors
Drupal.behaviors.Vanbinnenuit = {
    attach: function (context, settings) {
        const teasers = document.querySelectorAll(
            '.teaser'
        );

        if (!_.isEmpty(teasers)) {
            Array.from(teasers).forEach(teaser => {
                const link = teaser.getElementsByTagName('A')[0];

                if (!_.isNil(link)) {
                    clickableCard(teaser, link);
                }
            });
        }
    }
}